import AepZipCode from '@components/pages/account/aep/zip-code';

export default AepZipCode;
